import React, { useState, useMemo, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { GrHostMaintenance } from "react-icons/gr";
import { getYearsOptions } from "../../../utilities";
import GlobalSearchableDropdown from "../../Constant/SearchableDropdown";
import { getMaintenanceCostApi } from "../../../services/DashboardServices";
import { toast } from "react-toastify";
const MaintenanceCostChart = () => {
  const [yearOption, setYearOption] = useState(getYearsOptions);
  const [selectdeYear, setSelectedYear] = useState(yearOption[0]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getData = () => {
    setLoading(true);
    getMaintenanceCostApi({ year: selectdeYear?.value || "" })
      .then((res) => {
        setData(res?.data?.data || []);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, [selectdeYear]);

  const months = useMemo(() => data.map((item) => item.month), [data]);
  const values = useMemo(
    () => data.map((item) => item.cumulative_cost),
    [data]
  );

  const chartOptions = {
    series: [
      {
        name: "Yearly Trend",
        data: values,
      },
    ],
    options: {
      chart: { height: 350, type: "area", toolbar: { show: false } },
      dataLabels: { enabled: false },
      stroke: { curve: "smooth", width: 2, colors: ["#0d6efd"] },
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 0.4,
          opacityFrom: 0.5,
          opacityTo: 0,
          stops: [0, 90, 100],
        },
        colors: ["#0d6efd"],
      },
      grid: { borderColor: "#eee", yaxis: { lines: { show: true } } },
      xaxis: {
        categories: months,
        labels: { style: { colors: "#666" } },
        axisBorder: { show: true, color: "#ddd" },
        axisTicks: { show: true },
      },
      yaxis: { labels: { style: { colors: "#666" } } },
      tooltip: {
        y: {
          formatter: (val) => {
            if (val >= 1e12) return "₹" + (val / 1e12) + "T";
            if (val >= 1e7) return "₹" + (val / 1e7) + " Cr";
            if (val >= 1e5) return "₹" + (val / 1e5) + " L";
            if (val >= 1e3) return "₹" + (val / 1e3) + "K";
            return "₹" + val;
          },
        },
      },
      legend: { show: false },
    },
  };

  return (
    <div className="card shadow-sm border-0">
      <div className="pt-3 px-3 d-flex justify-content-between align-items-center gap-2 flex-wrap">
        <div className="d-flex align-items-center">
          <GrHostMaintenance size="15" />
          <h5 className="ms-1">Maintenance Cost</h5>
        </div>
        <GlobalSearchableDropdown
          isClearable={false}
          options={yearOption}
          selected={selectdeYear}
          onSelect={(item) => setSelectedYear(item)}
          placeholder="Year"
        />
      </div>
      <div className="p-3">
        <ReactApexChart
          options={chartOptions.options}
          series={chartOptions.series}
          type="area"
          height={250}
        />
      </div>
    </div>
  );
};

export default MaintenanceCostChart;
